"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var contextMenu;
    (function (contextMenu) {
        contextMenu._menu = null;
        contextMenu._show = $dyn.observable(false);
        contextMenu._options = null;
        contextMenu._taskRecorderProvider = null; // TODO: this type will need to be defined as part of the TaskRecorder conversion
        contextMenu._menuId = 0;
        contextMenu._showRootObserver = null;
        /**
         * Gets the next menuId
         * @internal
         * @returns The next menu Id.
         */
        function nextMenuId() {
            return $dyn.contextMenu._menuId++;
        }
        contextMenu.nextMenuId = nextMenuId;
        /**
         * sets the context menu provider (used by task recorder to overide the context menu)
         * @internal
         * @param contextMenuProvider the provider.
         */
        function setProvider(contextMenuProvider) {
            $dyn.contextMenu._taskRecorderProvider = contextMenuProvider;
        }
        contextMenu.setProvider = setProvider;
        /**
         * closes the context menu, all submenus and remove the handlers
         * @internal
         */
        function closeContextMenu() {
            // trigger all menus to close
            $(document.body).trigger("closeContextMenus");
            $dyn.contextMenu._menuId = 0;
            // remove the handlers
            $(document.body).off("click.dynContextMenu");
            $(document.body).off("resetShellOnNavigation.dynContextMenu");
            // find the context menu and any sub menus and remove them
            $(".contextMenuContainer").remove();
            $(".contextMenu").remove();
        }
        contextMenu.closeContextMenu = closeContextMenu;
        /**
         * Gets the context menu / initializes it as needed
         * @internal
         * @returns The context menu element.
         */
        function getContextMenu() {
            $dyn.contextMenu._menu = $("<div id='dynContextmenu' class='contextMenu layout-root-scope'></div>");
            $(document.body).append($dyn.contextMenu._menu);
            if ($dyn.contextMenu._options) {
                $dyn.contextMenu._options.flyout = $dyn.contextMenu._menu;
            }
            else {
                $dyn.contextMenu._options = {
                    autoClose: false,
                    flyout: $dyn.contextMenu._menu,
                    show: $dyn.contextMenu._show,
                    skipAria: true,
                };
                if ($dyn.contextMenu.contextControl && $dyn.contextMenu.contextControl.element) {
                    $dyn.contextMenu._options.target = $($dyn.contextMenu.contextControl.element);
                }
                $dyn.util.flyout($dyn.contextMenu._options, false);
            }
            return $dyn.contextMenu._menu;
        }
        contextMenu.getContextMenu = getContextMenu;
        /**
         * Gets the context menu options from the control and calls displayContextMenu
         * @internal
         * @param event The event triggering the show request.
         */
        function showContextMenu(event) {
            // get the hovered control
            var contextMenuControl = $dyn.contextMenu.contextControl;
            if (contextMenuControl && $dyn.value(contextMenuControl.HasContextMenuOptions) && contextMenuControl.GetContextMenuOptions) {
                var command = $dyn.value(contextMenuControl.GetContextMenuOptions);
                if (command) {
                    command([], function (result) {
                        if (result) {
                            var menu = void 0;
                            if (!$.isPlainObject(result)) {
                                menu = JSON.parse(result);
                            }
                            $dyn.contextMenu.displayContextMenu(event, menu);
                        }
                        else {
                            $dyn.contextMenu.displayContextMenu(event, null);
                        }
                    });
                }
            }
            else {
                $dyn.contextMenu.displayContextMenu(event, null);
            }
        }
        contextMenu.showContextMenu = showContextMenu;
        /**
         * Resets state aggregates the context menu options and displays the new context menu
         * @internal
         * @param event The event that triggered the context menu.
         * @param contextMenuData The context menu data.
         */
        function displayContextMenu(event, contextMenuData) {
            // get context menu
            var menu = $dyn.contextMenu.getContextMenu();
            var targetElement;
            if (event && event.target) {
                targetElement = event.target;
            }
            // clear the last one
            menu.children().remove();
            var contextMenuControl = $("<div data-dyn-role='ContextMenu' data-dyn-bind=\"\"></div>");
            menu.append(contextMenuControl);
            var list = [];
            // should we include the default menu options
            var includeDefaultMenu = true;
            if (contextMenuData && contextMenuData.OverrideSystemMenu) {
                includeDefaultMenu = false;
            }
            var contextControlScoped = $dyn.contextMenu.contextControl;
            var activeForm = $dyn.context($dyn.shell.getActiveForm());
            // if the context target and is not the form and if the control has a root use that
            if (activeForm !== contextControlScoped && contextControlScoped && contextControlScoped.Root) {
                activeForm = contextControlScoped.Root;
            }
            if (includeDefaultMenu) {
                if (activeForm && activeForm.FormName && contextControlScoped) {
                    // delegate determining the correct form and control name to show
                    $(targetElement).trigger("contextmenuoptions", [activeForm.FormName, contextMenu.contextControl, list]);
                }
                if (contextControlScoped && $dyn.applyFunction(contextControlScoped.isInGrid, contextControlScoped)) {
                    var parentGrid = contextControlScoped.element;
                    while (parentGrid) {
                        if (parentGrid.classList && (parentGrid.classList.contains("listRoot") || parentGrid.classList.contains("react-listRoot"))) {
                            break;
                        }
                        else {
                            parentGrid = parentGrid.parentNode;
                        }
                    }
                    if (parentGrid) {
                        var gridControl = $dyn.context(parentGrid);
                        if (gridControl && gridControl.getCommonGridContextMenuOptions) {
                            var exportOption = gridControl.getCommonGridContextMenuOptions(targetElement);
                            if (exportOption && exportOption.length > 0) {
                                list.push.apply(list, exportOption);
                            }
                        }
                    }
                }
                // Add client control level options
                if (contextControlScoped && typeof (contextControlScoped.getContextMenuOptions) === "function") {
                    contextControlScoped.getContextMenuOptions(targetElement).forEach(function (element) {
                        list.push(element);
                    });
                }
                // TODO: Should be in TaskRecorder.js
                // provider is set by the Task recorder when it is started and set to null when it stops
                if ($dyn.contextMenu._taskRecorderProvider) {
                    // the context menu makes use of the hovered control but for the Task recorder we need the inner most control which is got using the target from the event
                    var taskRecorderControl = $dyn.context(targetElement);
                    if (!taskRecorderControl) {
                        taskRecorderControl = contextControlScoped;
                    }
                    $dyn.contextMenu._taskRecorderProvider.prepareShow(list, taskRecorderControl);
                }
                // Add a "View Details" context menu item for controls that are a hyperlink.
                // We need to do this because currently, if a control has no value, there is no hyperlink and therefore no way to get to the details.
                if (contextControlScoped && $dyn.value(contextControlScoped.IsHyperlink) && !(contextControlScoped.Root && contextControlScoped.Root.TypeName === "DropDialogPopup")) {
                    var detailsOptions = {
                        Command: function () {
                            $dyn.flyout.flyoutManager.removeAllFlyoutsAsync()
                                .done(function () {
                                $dyn.applyFunction(contextControlScoped.ExecuteHyperlink, contextControlScoped);
                            });
                        },
                        Label: $dyn.label("ContextMenu_ViewDetails"),
                    };
                    list.push(detailsOptions);
                }
                // Add Update url option that will be visible if debug flag AllowUpdateUrl is set.
                // This is temporary, later to be moved to either a corresponding button or automatic url update (1042567).
                if ($dyn.debug.AllowUpdateUrl && activeForm && activeForm.UpdateRecordContext) {
                    var details = {
                        Command: function () {
                            $dyn.applyFunction(activeForm.UpdateRecordContext, activeForm);
                        },
                        Label: $dyn.label("ContextMenu_UpdateUrl"),
                    };
                    list.push(details);
                }
            }
            // add X++ options
            if (contextMenuData && contextMenuData.ContextMenuOptions && contextMenuData.ContextMenuOptions.length > 0) {
                // add x++ options
                contextMenuData.ContextMenuOptions.forEach(function (element) {
                    var option = {
                        Command: function () {
                            $dyn.contextMenu.optionalCommand(element.MenuOptionId);
                        },
                        Label: element.Label,
                    };
                    list.push(option);
                    // if the context menu has sub options
                    $dyn.contextMenu.addContextOptions(option, element);
                });
            }
            // if we don't have any options show the custom menu close it
            if (list.length === 0) {
                $dyn.contextMenu.closeContextMenu();
                return;
            }
            var addAccessibilityAttributes = function (contextMenuOption, index, length) {
                contextMenuOption.length = length;
                contextMenuOption.index = index;
                if (contextMenuOption.contextMenuOptions) {
                    for (var i = 0; i < contextMenuOption.contextMenuOptions.length; i++) {
                        addAccessibilityAttributes(contextMenuOption.contextMenuOptions[i], i, contextMenuOption.contextMenuOptions.length);
                    }
                }
            };
            // update the commands to allow the click to close the context menu
            for (var i = 0; i < list.length; i++) {
                $dyn.contextMenu.processOptions(list[i]);
                addAccessibilityAttributes(list[i], i, list.length);
            }
            $dyn.contextMenu.contextMenuOptions = list;
            var dataContext = {
                contextMenuOptions: $dyn.contextMenu.contextMenuOptions,
                contextMenuShow: $dyn.contextMenu._show,
                Id: $dyn.contextMenu.nextMenuId(),
                Root: activeForm
            };
            menu.show();
            // bind the data
            $dyn.dataBind(menu[0], dataContext);
            // clear left and top for case where we right click then left click to
            // remove menu and then right click without moving the mouse
            menu.css("left", "0");
            menu.css("top", "0");
            // first check if this is a F10 code
            // or is it a shiftKey (Edge will set this to true)
            // or is this a x/y of 0 (this is what IE sets if we are keyboarding an element
            // or event.button is 0 then it is not a mouse event
            if (event) {
                if (event.which === $dyn.ui.KeyCodes.f10 || event.shiftKey === true || (event.clientX === 0 && event.clientY === 0) || event.button === 0) {
                    $dyn.contextMenu._options.of = event.target;
                    $dyn.contextMenu._options.my = "center top";
                    $dyn.contextMenu._options.at = "center bottom";
                }
                else {
                    $dyn.contextMenu._options.my = "left top";
                    $dyn.contextMenu._options.of = event;
                }
            }
            if (activeForm && $dyn.value(activeForm.ActiveElement)) {
                $dyn.contextMenu._options.target = $($dyn.value(activeForm.ActiveElement));
            }
            $dyn.contextMenu._options.using = function (position) {
                var menuContext = $($dyn.contextMenu._menu).children()[0];
                var windowHeight = $(window).height();
                var windowWidth = $(window).width();
                // check for the case that the the context menu will run off the side of the screen
                if (position.left + $(menuContext).outerWidth() > windowWidth) {
                    position.left -= $(menuContext).outerWidth();
                }
                // check for the case that the the context menu will run off the bottom of the screen
                if (position.top + $(menuContext).outerHeight() > windowHeight) {
                    position.top -= $(menuContext).outerHeight();
                }
                // position the preview
                $(menu).css({ top: position.top });
                $(menu).css({ left: position.left });
            };
            $dyn.contextMenu._show(true);
            // Dispose old observer whenever display gets called or the context menu closes
            $dyn.contextMenu._showRootObserver = $dyn.observe($dyn.contextMenu._show, function (value) {
                if (!value) {
                    $dyn.contextMenu.closeContextMenu();
                    return false;
                }
            }, this, $dyn.contextMenu._showRootObserver, true /* skipFirstTimeFire */);
        }
        contextMenu.displayContextMenu = displayContextMenu;
        /**
         * Traverse the options and build out the commands
         * @internal
         * @param contextMenuOption The context menu options.
         */
        function processOptions(contextMenuOption) {
            var e_1, _a;
            if (contextMenuOption.Command) {
                var originalCommand_1 = contextMenuOption.Command;
                var newCommand = function (event) {
                    originalCommand_1(event);
                    $(document.body).trigger("closeContextMenus");
                };
                contextMenuOption.Command = newCommand;
            }
            if (contextMenuOption.contextMenuOptions) {
                try {
                    for (var _b = __values(contextMenuOption.contextMenuOptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var option = _c.value;
                        $dyn.contextMenu.processOptions(option);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
        contextMenu.processOptions = processOptions;
        /**
         * Add the option to the parent based on if its a submenu or a command
         * @internal
         * @param parentOption The parent context menu options.
         * @param contextMenuData The child context menu options.
         */
        function addContextOptions(parentOption, contextMenuData) {
            parentOption.contextMenuOptions = [];
            if (contextMenuData.ContextMenuOptions) {
                contextMenuData.ContextMenuOptions.forEach(function (element) {
                    // is this a sub menu?
                    var option;
                    if (element.ContextMenuOptions && element.ContextMenuOptions.length > 0) {
                        option = {
                            ContextMenuOptions: element.ContextMenuOptions,
                            Label: element.Label,
                        };
                        $dyn.contextMenu.addContextOptions(option, element);
                    }
                    else {
                        option = {
                            Command: function () {
                                $dyn.contextMenu.optionalCommand(element.MenuOptionId);
                            },
                            Label: element.Label,
                        };
                    }
                    parentOption.contextMenuOptions.push(option);
                });
            }
        }
        contextMenu.addContextOptions = addContextOptions;
        /**
         * The wrapper for custom commands so we can pass the menuOptionId (command called) back
         * @internal
         * @param menuOptionId The context menu option Id.
         */
        function optionalCommand(menuOptionId) {
            var contextMenuControl = $dyn.contextMenu.contextControl;
            if (contextMenuControl) {
                var command = $dyn.value(contextMenu.contextControl.SelectedMenuOption);
                if (command) {
                    command(menuOptionId);
                }
            }
        }
        contextMenu.optionalCommand = optionalCommand;
        /**
         * The handler to determine the context menu to open
         * @internal
         * @param e The event that triggered this handler.
         * @param shortCutOpen True if this was called from a short cut key handler.
         */
        function openContextMenuHandler(e, shortCutOpen) {
            // if there is a open context menu do not allow right click on it
            if ($dyn.contextMenu._menu && ($dyn.contextMenu._menu[0])) {
                if (e.target && ($(e.target).parents(".contextMenuContainer").length || $(e.target).hasClass("contextMenuContainer"))) {
                    e.preventDefault();
                    return;
                }
            }
            // check to see if there is a selected string
            var selected = $dyn.ui.getSelection();
            var textSelected;
            if (selected && selected.toString() !== "") {
                textSelected = true;
            }
            else {
                textSelected = false;
            }
            // In IE, the selected.toString() does not capture the selected text when it's in the grid.
            // We also need to check selectionEnd and selectionStart.
            if (!textSelected) {
                // is there a difference in the selectionEnd and selectionStart
                var target = e.target;
                var selectionLength = $dyn.ui.selectionEnd(target) - $dyn.ui.selectionStart(target);
                textSelected = selectionLength > 0;
            }
            // check to see if the target is an input
            var nodeName = e.target.nodeName.toLowerCase();
            var inInput;
            if (nodeName === "input" || nodeName === "textarea" || e.target.isContentEditable) {
                inInput = true;
            }
            else {
                inInput = false;
            }
            // check to see if target is input and provider is present then show context menu
            if ($dyn.contextMenu._taskRecorderProvider) {
                inInput = !$dyn.contextMenu._taskRecorderProvider.canShow(e);
            }
            // check to see if the target is an input
            var isImage;
            if (nodeName === "img") {
                isImage = true;
            }
            else {
                isImage = false;
            }
            // if there is a context menu close it.
            if ($dyn.contextMenu._show()) {
                $dyn.contextMenu.closeContextMenu();
            }
            $dyn.contextMenu.contextControl = $dyn.ui.getLiveControl(e.target);
            // dont show the AX context menu if we disable it via the flag useBrowserContextMenu or via the shell.disableContextMenu
            // if the control is an input disable it is if the input element is selected and AllowEdit is true but allow it if its a tree control
            // of if they select an image or have text selected
            var controlAllowContextMenu = ($dyn.contextMenu.contextControl &&
                (!$dyn.value($dyn.contextMenu.contextControl.AllowEdit) ||
                    ($dyn.contextMenu.contextControl instanceof $dyn.controls.Tree)));
            if (!$dyn.flags.useBrowserContextMenu &&
                !$dyn.shell.disableContextMenu &&
                (shortCutOpen ||
                    !inInput ||
                    controlAllowContextMenu) &&
                !isImage && !textSelected &&
                (!$dyn.activeForm() ||
                    !$dyn.context($dyn.activeForm()) ||
                    !$dyn.context($dyn.activeForm()).IsLightBox)) {
                e.preventDefault();
                // Special handling for the Tree control
                var tree = $dyn.contextMenu.contextControl;
                if (tree && tree instanceof $dyn.controls.Tree) {
                    var nodeId = $(e.target).closest(".treeView-treeItem").attr("data-dyn-id");
                    if (Number(nodeId) > 0) {
                        var treeNode = tree.NodeData(Number(nodeId));
                        if (treeNode && treeNode.ReactNode) {
                            // Tree node should be selected with the right click, this creates an additinal interaction
                            tree.SelectNode(treeNode.ReactNode, $dyn.ui.Tree.HowSelected.ByMouse, $dyn.ui.Tree.SelectionAction.Single);
                        }
                    }
                }
                // hook the click so we can close the menu if they click outside of the context menu
                $(document.body).on("click.dynContextMenu", function () {
                    $dyn.contextMenu.closeContextMenu();
                });
                $(document.body).on("resetShellOnNavigation.dynContextMenu", function () {
                    $dyn.contextMenu.closeContextMenu();
                });
                $dyn.contextMenu.showContextMenu(e);
            }
        }
        contextMenu.openContextMenuHandler = openContextMenuHandler;
    })(contextMenu = $dyn.contextMenu || ($dyn.contextMenu = {}));
    $(document).on("contextmenu", $dyn.contextMenu.openContextMenuHandler);
})($dyn || ($dyn = {}));

//# sourceMappingURL=DynContextMenu.js.map
